// import * as mns from '../../../mutation-types';

import * as mns from "@/store/mutation-types";

export default {
    state () {
        return {
            premierInvestComponent: 'Empty'
        }
    },
    getters: {
        premierInvestComponent(state){
            return state.premierInvestComponent;
        }
    },
    mutations: {
        [mns.SET_PREMIER_INVEST_COMPONENT](state, premierInvestComponent){
            state.premierInvestComponent = premierInvestComponent;
        },
    }
} // export.